import { EYE_HEIGHT, type WalkEvent, type WalkSnapshot, type WalkState } from './types.js';

// Pure reducer. Returns same reference on no-op transitions so dispatch
// can short-circuit equality.
export function walkTransition(state: WalkState, event: WalkEvent): WalkState {
  switch (event.type) {
    case 'TOGGLE_ACTIVE':
      // Inc C: ogni toggle riparte da altezza standing — si entra in piedi e
      // uscire azzera un eventuale crouch (HOLD 'c' non più premuto).
      return { ...state, active: !state.active, eyeHeight: EYE_HEIGHT };
    case 'EXIT':
      if (!state.active) return state;
      return { ...state, active: false, eyeHeight: EYE_HEIGHT };
    case 'SET_EYE_HEIGHT':
      // Inc C: no-op (stessa ref) se invariata → dispatch short-circuita.
      if (state.eyeHeight === event.eyeHeight) return state;
      return { ...state, eyeHeight: event.eyeHeight };
    case 'SET_VIEWBOX':
      // WS5 PR3.1: short-circuit equality su no-change + integer guard
      // (Codex PR3.1 W1): se arrayIdx non null/integer (NaN/Infinity/float),
      // rifiuta e mantieni state. Failsafe contro malformed dispatch dal
      // viewbox state-machine bridge in orchestrator.
      if (event.arrayIdx !== null && !Number.isInteger(event.arrayIdx)) return state;
      if (state.currentViewboxArrayIdx === event.arrayIdx) return state;
      return { ...state, currentViewboxArrayIdx: event.arrayIdx };
    case 'SET_FLOOR_HEIGHT':
      // 2026-06-05: scene-specific floor override. Failsafe contro NaN/Inf
      // dispatch (es. viewbox malformed o default_pos.y mancante).
      if (!Number.isFinite(event.floorHeight)) return state;
      if (state.floorHeight === event.floorHeight) return state;
      return { ...state, floorHeight: event.floorHeight };
  }
}

export function walkSnapshot(state: WalkState): WalkSnapshot {
  return {
    active: state.active,
    eyeHeight: state.eyeHeight,
    floorHeight: state.floorHeight,
    currentViewboxArrayIdx: state.currentViewboxArrayIdx,
  };
}
